import DecomFormPage from './decom-policy-form-layout';
import { pagesConfig } from '../../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../../shared/analytics/module-list';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../../utils/feature-flags';
import DecomFormPageOld from './decom-policy-form-layout-old';

export default function CloneDecomPolicyPage() {
  const { features } = useUserSettings();
  const isUiRefreshFeatureEnabled = isFeatureEnabled(
    'decommissioningUiUpdate',
    features
  );
  return (
    <SimpleBreadcrumbsPage
      isSubPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        {
          label: pagesConfig.decommissioningLayout.name,
        },
        {
          label: pagesConfig.decomPolicies.name,
          path: `${pagesConfig.decommissioningLayout.link}/${pagesConfig.decomPolicies.link}`,
        },
      ]}
    >
      {isUiRefreshFeatureEnabled ? (
        <DecomFormPage
          title={`${pagesConfig.cloneDecomPolicyFormPage.name}`}
          pageMode="clone"
        />
      ) : (
        <DecomFormPageOld
          title={`${pagesConfig.cloneDecomPolicyFormPage.name}`}
          pageMode="clone"
        />
      )}
    </SimpleBreadcrumbsPage>
  );
}
